export default __webpack_public_path__ + "static/media/cloud.97b1f583.svg";